import { Constants } from '../constants'
import { removeDuplicated } from './misc'

const MENTION_REGEX = /@[^\s]+/gi

type Mention = { id: string; name: string }

export function getActualMentionsInText(mentions: Mention[], textContent: string): string[] {
  if (!mentions || mentions.length === 0) return []

  const actualMentions = mentions.filter(mention => {
    const mentionName = typeof mention === 'string' ? mention : mention.name
    return textContent.includes(`@${mentionName}`)
  })

  return removeDuplicated(
    actualMentions.map(mention => typeof mention === 'string' ? mention : mention.id),
  )
}

export function isMaxMentionsReached(mentions: Mention[], text: string): boolean {
  const actualMentions = getActualMentionsInText(mentions, text)
  return actualMentions.length >= (Constants.maxMentions + 1)
}

export function createMentionRegex(mentionedUsers: any[] = []): RegExp {
  if (!mentionedUsers || mentionedUsers.length === 0) {
    return MENTION_REGEX
  }

  const patterns = mentionedUsers
    .map(user => {
      const name = user.name || user.id
      if (!name) return null
      return name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+')
    })
    .filter(Boolean)

  if (patterns.length === 0) {
    return MENTION_REGEX
  }

  const pattern = `@(${patterns.join('|')})`
  return new RegExp(pattern, 'gi')
}